import React from 'react';

export default function Error404() {
    return (
        <div>
            <h1>Error 404</h1>
        </div>
    );
}